module.exports = __webpack_public_path__ + "media/עט.ad0fbb09.mp3";